import { Component, OnInit, ViewChild, ElementRef, Signal, HostListener, AfterViewInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Validators, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InputValidationService } from '../helpers/validators/input-validation.service';
import { RegExValidation } from '../helpers/constants/regex-validation.constants';
import { NgbModal, NgbModalOptions ,NgbModule, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { SolUserModalService } from '../services/sol-user-modal.service';
import { OtpService } from '../services/otp.service';
import { CommonModule, NgIf, PlatformLocation } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { Guid } from 'guid-typescript';
import * as $ from 'jquery';
import { Enum } from '../helpers/enums/enum';
import { RegistrationRoutingService } from '../services/registration-routing.service';
import { UserAuthService } from '../services/user-auth.service';
import { CampaignService } from '../services/campaign.service';
import { DataLayerService } from '../services/datalayer.service';
import { BasicInfoService } from '../services/basic-info.service';
import { UtilService } from '../services/util.service';
import { NumericFieldDirective } from '../helpers/directive/numeric-field.directive';
import { PasswordStrengthBar } from '../helpers/components/password-strength-bar';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { FormDirective } from '../helpers/directive/form.directive';
import { NameFieldHyphenSpaceDirective } from '../helpers/directive/name-field-hyphen-space.directive';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { DEFAULT_MODAL_OPTIONS, ERROR_MESSAGES, MESSAGE_LINK_TEMPLATE, scrollToTop } from '../shared/constants/app.constants';
import { RegisterFormService } from '../services/register-form.service';
import { LogoComponent } from '../logo/logo.component';
import { NeedHelpComponent } from '../shared/need-help.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  host: { 'class': 'ipadfooterbottom' },
  standalone: true,
  imports: [
      TrackingDirective,
      RouterLink,
      NgIf,
      FormsModule,
      ReactiveFormsModule,
      NumericFieldDirective,
      PasswordStrengthBar,      
      NgbModule,
      CommonModule,
      FormDirective,
      NameFieldHyphenSpaceDirective,
      NgbAccordionModule,LogoComponent,NeedHelpComponent
  ]
})
export class RegisterComponent implements OnInit, AfterViewInit {
  
  @ViewChild('otpModel', { static: false }) otpModel: ElementRef;
  @ViewChild('captureIncomeModel', { static: false }) captureIncomeModel: ElementRef;
  @ViewChild('securityQuestionsModel', { static: false }) securityQuestionsModel: ElementRef;
  @ViewChild('artcileNudge', { static: false }) button: any;
  modalOptions: NgbModalOptions;
  userData = null;
  visible:boolean=true;
  changetype:boolean=true;
  visiblec:boolean=true;
  changetypec:boolean=true;
  registerForm; otpForm; captureIncomeForm; captureIncomeModelRef; idNumberFormCampaign; idNumberFormSecondCampaign;
  errorMsg = ''; securityQuestionErrorMsg = ''; signupSuccess = false;
  otpErrorMsg = '';
  password = '';
  captureIncomeErrorMsg = '';
  cellNumberErrorMsg = '';
  sendOtpText = 'Send SMS OTP';
  sendEmailOtpText = 'Send Email OTP';
  otpPopupHeaderText = 'Get your One-Time Pin (OTP) via SMS';
  securityQuestionList = [];
  basicInfoVerifyConfirmed: any;
  securityQuestionAttempt = 1;
  successMsg = '';
  time;
  btnOTPIsDisabled = false;
  usedOtpType;
  isOtpSent = false;
  isIdNumber = true;
  idNumber;
  registerWithIdnumberForm;
  idNumberForm;
  messageLinkTemplet = MESSAGE_LINK_TEMPLATE;
  WebSource = '';
  Params = '';  
  internalServerErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
  isHidden: boolean = false;
  currentYear = new Date().getFullYear();
  env = environment;
  appInsights: any;
  campaignData;
  utm_id: string;
  campaignCookieName: string = "user_campaign"
  showCampaignWithId: boolean = false;
  campaignId = '';
  primaryHeading = '';
  secondaryHeading = '';
  primaryRemaining = '';
  secondaryRemaining = '';
  campaignIdNumberCheck = '';
  campCheck: boolean = false;
  showSecondCampaign: boolean = false;
  primaryHeadingSecondPage;
  primarySeondaryRemaining;
  showDefaultCampaign: boolean = true;
  showCampaignWithOutId;
  campaignSecondCheck: boolean = false;
  code: Guid;
  documentPdfAssociateId;
  imageUrlCheck : boolean = false;
  imageUrl ='';
  showDefaultImage: boolean = false;
  defaultImage = '../../assets/images/scs-landing-img-web.png';
  campaignLinkedPage: string ='';
  isRestrictedUser: any;
  utm_source: string;
  returnXPostbackBaseUri = environment.returnXPostbackBaseUrl;
  returnXTrackingUrl = '';
  ischatbotSQConfirmed: boolean = false;
  isDesktop: Signal<boolean>;
  showTooltip = false;
  ignoreNextDocClick = false;
  constructor(
    private readonly userService: UserService,
    private readonly otpService: OtpService,
    public readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly solUserModalService: SolUserModalService,
    private readonly spinner: NgxSpinnerService,
    private readonly location: PlatformLocation,
    private readonly cookieService: CookieService,
    private readonly oauthService: OAuthService,
    private readonly titleService: Title,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userAuthService: UserAuthService,
    private readonly registrationRouting: RegistrationRoutingService,
    private readonly campaignService: CampaignService,
    private readonly dataLayerService:DataLayerService,
    private readonly basicInfoService: BasicInfoService,
    private readonly utilService: UtilService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly registerFormService: RegisterFormService
  ) {
    this.isDesktop = toSignal(
      this.breakpointObserver 
        .observe('(min-width: 768px)')
        .pipe(map(result => result.matches)),
      { initialValue: false }
    );

    this.modalOptions = DEFAULT_MODAL_OPTIONS;
    this.location.onPopState(() => this.modalService.dismissAll());
    this.titleService.setTitle('Register For Credit Management & Support | Sanlam Credit Solutions');
  }

  ngOnInit() {
    const lastPublicRoute = sessionStorage.getItem('lastPublicRoute');
    const isRegisterPath = (this.router.url || '').split('?')[0].toLowerCase() === '/register';
    const hasLastHlRegistrationRoute = !!lastPublicRoute && lastPublicRoute.toLowerCase().startsWith('/hl-registration');

    if (isRegisterPath && hasLastHlRegistrationRoute) {
      this.router.navigateByUrl(lastPublicRoute);
      return;
    }
    sessionStorage.removeItem('branchUserLogin');
    this.userData = this.userAuthService.getIdentityClaims();
    localStorage.removeItem('tempToken');
    localStorage.removeItem('number');
    localStorage.removeItem('verification');
    localStorage.removeItem('userId');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('userPhoneNumber');
    this.checkIntermediaryLink();
    this.registerForm = this.registerFormService.buildRegisterForm();



    this.registerWithIdnumberForm = this.formBuilder.group({
      IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]],
      Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
      ConfirmPassword: ['', Validators.required],
      Email: ['', [Validators.required, Validators.email, InputValidationService.isValidEmail]],
      FinancialPlannerCode: ['', [Validators.minLength(8)]],
      WebSource: '',
      Params: '',
      RegistrationSource: '',
      AcceptTerms: [false, Validators.pattern('true')]
    }, {
      validator: [
        InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
      ],
    });

    this.otpForm = this.formBuilder.group({
      Otp: ['', [Validators.required, Validators.minLength(4)]],
    });

    this.captureIncomeForm = this.formBuilder.group({
      GrossIncome: ['', [Validators.required, Validators.min(1)]],
    });

    this.idNumberForm = this.formBuilder.group({
      IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]]
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params?.idnumber) {
        this.idNumber = params.idnumber;
        this.validateIdNumber();
      }
      if (params) {
        if (params.websource || params.WebSource ||
          params.WEBSOURCE || params.webSource) {
          this.WebSource = params.websource || params.WebSource || params.WEBSOURCE || params.webSource;
        }

        if(params.utm_source)
        {
            this.utm_source = params.utm_source;
            this.registrationRouting.routeTo(this.utm_source);
        }

        if (params.articleId) {
          this.WebSource = params.articleId;
        }
        if (params.Id) {
          this.campaignId = params.Id;
        }
        if (params.utm_id || params.utm_ID || params.Utm_id || params.Utm_ID) {
          this.utm_id = params.utm_id || params.utm_ID || params.Utm_id || params.Utm_ID;
        }
        if (params.code || params.Code) {
          this.code = params.code || params.Code;
        }

        this.Params = this.registrationRouting.queryStringParams();
      }

    });
    this.checkPreviousUrl();
    this.bindActiveCampaign();
    this.checkIntermediaryLink();
    this.idNumberFormCampaign = this.formBuilder.group({
      IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]]
    });

    this.idNumberFormSecondCampaign = this.formBuilder.group({
      IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]]
    });


    this.userAuthService.logoutActiveUser(globalThis.location.origin + '/register');
  }

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.articleId) {
        this.button.nativeElement.setAttribute('Category', "Article Nudge");
        this.button.nativeElement.setAttribute('SubCategory', "Registration");
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      const utmId = params['utm_id']?.trim().toLowerCase();
      if (utmId === 'returnx') {
        sessionStorage.setItem('utm_id', utmId);

        if (params['offer_id']) {
          sessionStorage.setItem('offer_id', params['offer_id']);
        }
        if (params['track_id']) {
          sessionStorage.setItem('track_id', params['track_id']);
        }
      }
    });
  }

  get registerFormControls() { return this.registerForm.controls; }
  get otpFormControls() { return this.otpForm.controls; }
  get captureIncomeFormControls() { return this.captureIncomeForm.controls; }
  get registerWithIdnumberFormControls() { return this.registerWithIdnumberForm.controls; }
  get idNumberFormControls() { return this.idNumberForm.controls; }
  get idNumberFormCampaignControls() { return this.idNumberFormCampaign.controls; }
  get idNumberFormSecondCampaignControls() { return this.idNumberFormSecondCampaign.controls; }
  viewpass(){
    this.visible=!this.visible;
    this.changetype=!this.changetype;
  }
  viewpassofConfirm(){
    this.visiblec=!this.visiblec;
    this.changetypec=!this.changetypec;
  }
  startTimeOut() {
    globalThis.onload = () => {
      this.resetTimer();
    };

    document.onmousemove = () => {
      this.resetTimer();
    };

  }

  resetTimer() {
    if (this.time !== 'stop') {
      console.log('no Idle');
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        console.log('timeout');
        this.modalService.dismissAll();
        this.resetRegisterForm();
        this.errorMsg = 'Your session has timed-out. Please try to register again.';
      }, 5 * 60 * 1000);
      }
  }

  stopTimer() {
    clearTimeout(this.time);
    this.time = 'stop';
    console.log('Timer Stop');
    console.log(this.time);
  }

  private isSolUserError(err: HttpErrorResponse): boolean {
    return err?.status === 423;
  }

  validateIdNumber() {
    localStorage.removeItem('tempToken');
    const params = {
      IdNumber: this.idNumber
    }
    this.userService.validateIdNumber(params).subscribe((data: any) => {
      localStorage.setItem('tempToken', data.token);
      this.isIdNumber = false;
      $('#id-number-form').hide();
      $('#auto-register-form').show();
      this.registerWithIdnumberForm.patchValue({ IdNumber: this.idNumber });
     },
      (err: HttpErrorResponse) => {
        if (this.isSolUserError(err)) {
          this.isIdNumber = true;
          this.solUserModalService.show();
        } else if (err.status === 409) {
          this.azureAdlogin(false);
        } else {
          this.isIdNumber = true;
        }
      });
  }

  registerWithIdNumber() {
    this.errorMsg = '';
    this.otpErrorMsg = '';
    this.cellNumberErrorMsg = '';
    this.securityQuestionErrorMsg = '';
    if (this.registerWithIdnumberForm.invalid) {
      this.registerWithIdnumberForm.markAllAsTouched();
      return;
    }

    this.registerWithIdnumberForm.patchValue({
      IdNumber: this.registerWithIdnumberForm.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      WebSource: this.WebSource,
      Params: this.Params,
      RegistrationSource: Enum.VersionType.ScsRegistration
    });
     this.userService.fetchUserDetailsByIdNumber(this.idNumber).subscribe({
      next: (data: any) => {
        this.ischatbotSQConfirmed = data.isVerified;
        localStorage.setItem('ischatbotSQConfirmed', this.ischatbotSQConfirmed.toString());
      }
    });
    this.userService.registerWithIdNumber(this.registerWithIdnumberForm.value).subscribe((data: any) => {
      if (data.status === 200) {
        this.registerForm.patchValue({ PhoneNumber: data.phoneNumber });
      this.userService.fetchUserDetailsByIdNumber(this.idNumber).subscribe({
      next: (data: any) => {
        this.ischatbotSQConfirmed  = data.isVerified;
        localStorage.setItem('ischatbotSQConfirmed ', this.ischatbotSQConfirmed .toString());
      }
      });
        this.validateUserBasicInfoWithBureau();
        this.startTimeOut();
      } else {
        this.errorMsg = data.message;
      }
     },
      (err: HttpErrorResponse) => {
        if (this.isSolUserError(err)) {
          this.solUserModalService.show();
        }
      });
    scrollToTop();
  }

  register() {
    localStorage.removeItem('tempToken');
    sessionStorage.setItem('userPhoneNumber',this.registerForm.value.PhoneNumber);
    sessionStorage.setItem('userEmail',this.registerForm.value.Email);
    this.errorMsg = '';
    this.otpErrorMsg = '';
    this.cellNumberErrorMsg = '';
    this.securityQuestionErrorMsg = '';
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    this.prepareRegisterFormValues();
    this.applyCampaignCookieToRegisterForm();
    this.trackReturnXRegisterPostback();
    this.submitRegisterForm();

    scrollToTop();
  }

  private prepareRegisterFormValues() {
    const intermediaryDataCode = localStorage.getItem('intermediaryDataCode');
    console.log('intermediarycode', intermediaryDataCode);
    const commonValues = {
      FirstName: this.registerForm.controls.FirstName.value.replace(RegExValidation.textName, ''),
      Surname: this.registerForm.controls.Surname.value.replace(RegExValidation.textWithSpace, ''),
      PhoneNumber: this.registerForm.controls.PhoneNumber.value.replace(RegExValidation.numeric, ''),
      IdNumber: this.registerForm.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      FinancialPlannerCode: this.registerForm.controls.FinancialPlannerCode.value.replace(RegExValidation.numeric, ''),
      WebSource: this.WebSource,
      Params: this.Params,
      RegistrationSource: Enum.VersionType.ScsRegistration
    };

    if (intermediaryDataCode && intermediaryDataCode != '') {
      this.registerForm.patchValue({
        ...commonValues,
        IntermediaryCodeGuidId: Guid.parse(intermediaryDataCode).toString(),
      });
      this.trackIntermediaryUserAssociateRegister();
    }
    else {
      this.registerForm.patchValue(commonValues);
    }
  }

  private applyCampaignCookieToRegisterForm() {
    const cookie = this.cookieService.get(this.campaignCookieName);
    if (cookie !== null && cookie !== '') {
      this.registerForm.value.campaignId = cookie;
    }
  }

  private trackReturnXRegisterPostback() {
    const isutmIdReturnX = sessionStorage.getItem('utm_id') === 'returnx';
    if (!isutmIdReturnX) {
      return;
    }
    const isLeadSent = sessionStorage.getItem('IsLeadSent');
    if (isLeadSent === 'true') {
      return;
    }
    const offerId = sessionStorage.getItem('offer_id');
    const trackId = sessionStorage.getItem('track_id');

    if (!(offerId && trackId && this.registerForm.value.PhoneNumber)) {
      return;
    }

    let returnXTrackingUrl = '';
    if (environment.production && !environment.preproduction) {
      returnXTrackingUrl = `${this.returnXPostbackBaseUri}?offer_id=${offerId}&transaction_id=${trackId}&adv_unique5=${this.registerForm.value.PhoneNumber}`;
    } else {
      returnXTrackingUrl = `${this.returnXPostbackBaseUri}?offer_id=${offerId}&aff_id=2&source=testoffer&aff_sub=testoffer&track_id=${trackId}&adv_unique5=${this.registerForm.value.PhoneNumber}`;
    }

    const img = new Image();
    console.log("Tracking URL hit successfully");
    sessionStorage.setItem('IsLeadSent', 'true');
    img.src = returnXTrackingUrl;
  }

  private submitRegisterForm() {
    this.userService.register(this.registerForm.value).subscribe({
      next: (data: any) => this.handleRegisterSuccess(data),
      error: (err: HttpErrorResponse) => this.handleRegisterError(err)
    });
  }

  private handleRegisterSuccess(data: any) {
    if (data.status === 200) {
      localStorage.setItem('tempToken', data.token);
      this.userService.fetchUserDetailsByIdNumber(this.idNumber).subscribe({
        next: (data: any) => {
          this.ischatbotSQConfirmed = data.isVerified;
          localStorage.setItem('ischatbotSQConfirmed', this.ischatbotSQConfirmed.toString());
        }
      });
      this.validateUserBasicInfoWithBureau();
      this.startTimeOut();
    }
    else {
      this.errorMsg = data.message;
    }
  }

  private handleRegisterError(err: HttpErrorResponse) {
    if (this.isSolUserError(err)) {
      this.solUserModalService.show();
    } else if (err.status === 409) {
      this.errorMsg = err.error.join('<br>');
      this.createMessageLink();
    } else if (err.status === 410) {
      this.cellNumberErrorMsg = err.error;
    } else {
      this.errorMsg = err.error;
    }
  }

  resetRegisterForm() {
    this.registerForm.reset();
    this.registerForm.markAsUntouched();
  }

  validateUserBasicInfoWithBureau() {
    this.otpErrorMsg = '';
    this.basicInfoVerifyConfirmed = false;
    this.spinner.show();
    this.basicInfoService.validateUserBasicInfoWithBureau().subscribe((data: any) => {
      if (data.isVerify === true) {
        this.basicInfoVerifyConfirmed = true;
        this.isRestrictedUser=false;
      } else {
        this.basicInfoVerifyConfirmed = false;
        this.isRestrictedUser=data.isRestrictedUser;
      }
      localStorage.setItem('verification', this.basicInfoVerifyConfirmed);
      console.log('value of basicINfo'+this.basicInfoVerifyConfirmed);

      this.openOtpPopup();
    },
      (err: HttpErrorResponse) => {

      this.openOtpPopup();
      });

  }

  openOtpPopup() {

    localStorage.setItem('number', this.registerFormControls.PhoneNumber.value);
    localStorage.setItem('verification', this.basicInfoVerifyConfirmed);
    if (this.WebSource) {
     this.router.navigateByUrl('/otp' + this.registrationRouting.queryStringParams());
    }
    else {
      this.router.navigate(['/otp']);
    }
  }

  sendOtp(otpType) {
    this.otpErrorMsg = '';
    this.otpForm.reset();
    const param = {
      OtpType: otpType,
    };

    this.usedOtpType = otpType;
    this.otpService.sendOtp(param).subscribe((data: any) => {
      this.otpPopupHeaderText = 'Your OTP has been sent to you, please enter it below';
      this.isOtpSent = true;
      if (otpType === 1) {
        if (this.sendOtpText === 'Resend SMS OTP') {
          this.successMsg = 'Resend SMS OTP sent successfully';
        }
        this.sendOtpText = 'Resend SMS OTP';
      } else {
        if (this.sendEmailOtpText === 'Resend Email OTP') {
          this.successMsg = 'Resend Email OTP sent successfully';
        }
        this.sendEmailOtpText = 'Resend Email OTP';
      }
    },
      (err: HttpErrorResponse) => {
        if (err.status === 429) {
          this.otpErrorMsg = 'OTP count exceeded, Try after some time';
        }
      });
  }

  validateOtp() {
    if (this.btnOTPIsDisabled) {
      return;
    }
    this.btnOTPIsDisabled = true;
    this.otpErrorMsg = '';
    if (this.otpForm.invalid) {
      this.otpForm.markAllAsTouched();
      this.btnOTPIsDisabled = false;
      return;
    }
    const param = {
      Otp: parseInt(this.otpForm.value.Otp),
      OtpType: this.usedOtpType
    };

    this.otpService.validateOtp(param).subscribe((data: any) => {
      this.btnOTPIsDisabled = false;
      setTimeout(() => {
        this.closeOtpPopup();
        // now check if verify ok and otp ok no need for open security question
        if (this.basicInfoVerifyConfirmed === false) {
      if(this.isRestrictedUser==false){
          this.openSecurityQuestions();
      }
        }
        else {
          this.dataLayerService.dataLayerCallback(true,'New User Register Successfully',sessionStorage.getItem('userEmail'),sessionStorage.getItem('userPhoneNumber'))
          { this.login(); }

        }
      }, 500);
    },
      (err: HttpErrorResponse) => {
        this.btnOTPIsDisabled = false;
        if (err.status === 422) {
          this.otpErrorMsg = 'Invalid OTP';
        }
      });
  }

  closeOtpPopup() {
    this.modalService.dismissAll();
    this.otpForm.reset();
    this.sendOtpText = 'Send SMS OTP';
    this.sendEmailOtpText = 'Send Email OTP';
  }
  openSecurityQuestions() {
    this.modalService.dismissAll();
    localStorage.setItem('RegisterUrl', '/register');
    if (this.WebSource) {
      this.router.navigateByUrl('/security-question' + this.registrationRouting.queryStringParams());
    }
    else {
      this.router.navigate(['/security-question']);
    }
  }

  login() {
    this.modalService.dismissAll();
    this.stopTimer();
    this.spinner.show();
    this.azureAdlogin(true);
  }

  openGrossIncomePopup() {
    this.captureIncomeModelRef = this.modalService.open(this.captureIncomeModel, this.modalOptions);
    this.captureIncomeModelRef.result.then((result: any) => {
    }, (reason: any) => {
      if (reason === 'Cross click') {
        this.openLandingHomePage();
      }
    });
  }


  updateIncome() {
    this.captureIncomeErrorMsg = '';
    if (this.captureIncomeForm.invalid) {
      this.captureIncomeForm.markAllAsTouched();
      return;
    }

    if (this.toNumber(this.captureIncomeForm.value.GrossIncome) >= 0) {
      this.captureIncomeForm.value.GrossIncome = parseFloat(this.toNumber(this.captureIncomeForm.value.GrossIncome));
    }

    this.userService.updateGrossIncome(this.captureIncomeForm.value).subscribe({
      next: () => {
        this.openLandingHomePage();
      },
      error: (err: HttpErrorResponse) => {
        this.captureIncomeErrorMsg = err.error;
      }
    });

  }

  openLandingHomePage() {
    this.modalService.dismissAll();
    this.router.navigate(['/portal/home']);
  }
  toNumber(val: any) {
    return this.utilService.toNumber(val);
  }

  changeGrossIncome() {
    if (this.captureIncomeForm.value.GrossIncome.toString().trim() === 'R') {
      this.captureIncomeForm.patchValue({
        GrossIncome: ''
      });
    }
  }

  azureAdlogin(isRegistrationSuccess: boolean) {
    localStorage.removeItem('tempToken');
    let submissionId = '';
    let submissionCode = Guid.create().toString();
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }

    if (isRegistrationSuccess) {
      submissionCode = '0df6b091-5d71-4f75-a6df-2d6a016e3709';
    }

    this.activatedRoute.queryParams.subscribe(params => {
      const utmId = params['utm_id']?.trim().toLowerCase();
      if (utmId === 'returnx') {
        sessionStorage.setItem('utm_id', utmId);

        if (params['offer_id']) {
          sessionStorage.setItem('offer_id', params['offer_id']);
        }
        if (params['track_id']) {
          sessionStorage.setItem('track_id', params['track_id']);
        }
      }
    });

    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {

      this.campaignService.getActiveCampaign('', campaignCookie).subscribe({
        next: (data: any) => {
          console.log('active campaign data', data);
          const tileHighlightId = data.tileHighlightId || '';
          const highlightParts: string[] = tileHighlightId ? tileHighlightId.split("#") : ['', ''];
          let highlightParam1 = highlightParts[0] || '';
          let highlightParam2 = highlightParts[1] || '';
          sessionStorage.setItem("productId",highlightParam1)
          sessionStorage.setItem("categoryId",highlightParam2)
         
          if (data?.campaignUtmId) {
            this.utm_id = data.campaignUtmId;
            this.campaignLinkedPage = data.campaignLinkedPage;
            const linkedCampaignList: string[] = [
              '/portal/home', '/portal/dashboard', '/portal/account',
              '/portal/offers', '/portal/budget', '/portal/profile', '/portal/faq', '/portal/setting'
            ];
  
            const isCampaignPageMatch: boolean = linkedCampaignList.includes(this.campaignLinkedPage);
  
            if (this.utm_id !== '' && this.utm_id !== undefined && this.campaignLinkedPage !== '' && isCampaignPageMatch) {
  
             this.oauthService.redirectUri = globalThis.location.origin + data.campaignLinkedPage;
            }
          }
          this.oauthService.initLoginFlow('', {
            submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
            instrumentationKey: environment.appInsights.instrumentationKey,
            utm_id: this.utm_id
          });
        },
        error: (err: HttpErrorResponse) => {}
      });
    }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }

  }

  idNumberCheck() {
    localStorage.removeItem('tempToken');
    this.errorMsg = '';
    if (this.idNumberForm.invalid) {
      this.idNumberForm.markAllAsTouched();
      return;
    }

    const param = {
      IdNumber: this.idNumberForm.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      Version: Enum.VersionType.ScsRegistration
    };
    this.idNumber = param.IdNumber;
    this.userService.getUserInfoByIdNumber(param).subscribe({
      next: (data: any) => {
        if (data.isLead) {
          this.isHidden = data.isEmailInRequestParam;
          if (this.isHidden === true) {
            this.registerWithIdnumberForm = this.formBuilder.group({
              IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]],
              Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
              ConfirmPassword: ['', Validators.required],
              Email: ['', [Validators.email, InputValidationService.isValidEmail]],
              FinancialPlannerCode: ['', [Validators.minLength(8)]],
              WebSource: '',
              Params: '',
              RegistrationSource: '',
              AcceptTerms: [false, Validators.pattern('true')]
            }, {
              validator: [
                InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
              ],
            });
          }
          localStorage.setItem('tempToken', data.token);
          $('#id-number-form').hide();
          $('#auto-register-form').show();
          this.registerWithIdnumberForm.patchValue({ IdNumber: this.idNumber });
          this.idNumberForm.patchValue({ IdNumber: ''});
        }
        else {
          $('#id-number-form').hide();
          $('#registerForm').show();
          this.registerForm.patchValue({ IdNumber: this.idNumber });
          this.idNumberForm.patchValue({ IdNumber: ''});
        }
      },
      error: (err: HttpErrorResponse) => {
         if (this.isSolUserError(err)) {
           this.solUserModalService.show();
           return;
         }
         if (err.error?.errors) {
          this.errorMsg = Object.values(err.error.errors).flat().join('<br>');
        } else {
      
          this.errorMsg = err.error;
          this.createMessageLink();
        }
      }
    });
  }

  createMessageLink() {
    if (this.errorMsg.includes('{LOGIN-LINK}')) {

      this.messageLinkTemplet = this.messageLinkTemplet.replace('linkText', 'Login').replace('routeValue', '/login')
      this.errorMsg = this.errorMsg.replace('{LOGIN-LINK}', this.messageLinkTemplet);
    }
    else if (this.errorMsg.includes('{REGISTER-LINK}')) {
      this.messageLinkTemplet = this.messageLinkTemplet.replace('linkText', 'REGISTER').replace('routeValue', '/register');
      this.errorMsg = this.errorMsg.replace('{REGISTER-LINK}', this.messageLinkTemplet);
    }
  }

  // dataLayerCallback(callback: boolean) {
  //   window['dataLayer'] = window['dataLayer'] || [];
  //   window['dataLayer'].push({
  //     'event': 'New User Register Successfully'
  //   });
  // }

  checkPreviousUrl() {
    localStorage.removeItem('RegisterUrl');
    localStorage.removeItem('OnLoadCheck');
    let error = localStorage.getItem('errorMsg');
    if (error === null) {
      localStorage.removeItem('errorMsg');
    }
    else {
      this.errorMsg = error;
      setTimeout(() => {
        localStorage.removeItem('errorMsg');
      }, 1000);
    }
  }

  azureActivelogin() {
    let submissionId = '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();

    this.activatedRoute.queryParams.subscribe(params => {
      const utmId = params['utm_id']?.trim().toLowerCase();
      if (utmId === 'returnx') {
        sessionStorage.setItem('utm_id', utmId);

        if (params['offer_id']) {
          sessionStorage.setItem('offer_id', params['offer_id']);
        }
        if (params['track_id']) {
          sessionStorage.setItem('track_id', params['track_id']);
        }
      }
    });

    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {
      this.campaignService.getActiveCampaign('', campaignCookie).subscribe({
        next: (data: any)=> {
          const tileHighlightId = data.tileHighlightId || '';
          const highlightParts: string[] = tileHighlightId ? tileHighlightId.split("#") : ['', ''];
          let highlightParam1 = highlightParts[0] || '';
          let highlightParam2 = highlightParts[1] || '';
          sessionStorage.setItem("productId",highlightParam1)
          sessionStorage.setItem("categoryId",highlightParam2)
          console.log('active campaign data', data);
          if (data?.campaignUtmId) {
            this.utm_id = data.campaignUtmId;
          }
          this.oauthService.initLoginFlow('', {
            submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
            instrumentationKey: environment.appInsights.instrumentationKey,
            utm_id: this.utm_id
          });
        },
        error: (err: HttpErrorResponse) => {}
      });
    }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }
  }

  logout() {
    (globalThis as any).fcWidget.destroy();
    this.cookieService.delete('submissionId', '/');
    this.cookieService.delete('userId', '/');
    this.cookieService.delete('isBranchUserComing','/');
    this.userAuthService.logOut();
    localStorage.removeItem('isLogout');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('userPhoneNumber');
  }

  private redirectToRegisterWithoutQueryParams(): void {
    if (this.utm_id && this.utm_id !== '') {
      sessionStorage.setItem('utm_id', this.utm_id);
    }

    this.oauthService.redirectUri = this.env.azureAdConfig.authConfig.redirectUri;
    this.router.navigate(['/'], {
      queryParams: {},
      replaceUrl: true
    });
  }

  private restoreCampaignFromCookieOrDefault(): void {
    const campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (!campaignCookie) {
      this.showDefaultCampaign = true;
      this.redirectToRegisterWithoutQueryParams();
      return;
    }
    this.campaignService.getActiveCampaign("", campaignCookie).subscribe({
      next: (cookieCampaign: any) => {
        if (!cookieCampaign) {
          this.cookieService.delete(this.campaignCookieName);
          this.showDefaultCampaign = true;
          this.redirectToRegisterWithoutQueryParams();
          return;
        }

        this.campaignData = cookieCampaign;
        this.campaignLinkedPage = cookieCampaign.campaignLinkedPage;
        this.utm_id = cookieCampaign.campaignUtmId || this.utm_id;
        this.showDefaultCampaign = false;

        if (this.campaignData.campaignTypeId !== Enum.CampaignType.LoginPageCampaign) {
          sessionStorage.setItem('isCampaignUserDcQuote', 'true');
        }

        this.bindCampaignText(this.campaignData);

        if (this.campaignData.campaignTypeId !== Enum.CampaignType.LoginPageCampaign) {
          this.router.navigate(['/'], {
            queryParams: this.utm_id ? { utm_id: this.utm_id } : {},
            replaceUrl: true
          });
        }
      },
      error: () => {
        this.showDefaultCampaign = true;
        this.redirectToRegisterWithoutQueryParams();
      }
    });
  }

  bindActiveCampaign() {
    if (this.utm_id && this.utm_id !== '') {
      this.campaignService.getActiveCampaign(this.utm_id, "").subscribe({
        next: (data: any) => this.handleUtmActiveCampaignResponse(data),
        error: () => this.restoreCampaignFromCookieOrDefault()
      });
    }
    else {
      this.bindActiveCampaignFromCookie();
    }
  }

  private handleUtmActiveCampaignResponse(data: any) {
    if (data == null) {
      this.restoreCampaignFromCookieOrDefault();
      return;
    }
    console.log("campaign data", data);
    this.campaignData = data;
    this.campaignLinkedPage = data.campaignLinkedPage;
    if (this.campaignData.campaignTypeId !== Enum.CampaignType.LoginPageCampaign) {
      sessionStorage.setItem('isCampaignUserDcQuote', 'true');
    }

    this.applyCampaignRedirectUri(data);
    this.bindCampaignText(this.campaignData);
    this.persistCampaignCookie(data);

    //  redirecting to b2c login page for campaign type 2 (login campaigns)
    if (this.campaignData.campaignTypeId === Enum.CampaignType.LoginPageCampaign && this.campaignData.campaignUtmId.toLowerCase() === this.utm_id.toLowerCase()) {
      this.azureAdlogin(false);
    }
  }

  private applyCampaignRedirectUri(data: any) {
    const linkedCampaignList: string[] = [
      '/portal/home', '/portal/dashboard', '/portal/account',
      '/portal/offers', '/portal/budget', '/portal/profile', '/portal/faq', '/portal/setting'
    ];

    const isCampaignPageMatch: boolean = linkedCampaignList.includes(this.campaignLinkedPage);

    if (this.utm_id !== '' && this.utm_id !== undefined && this.campaignLinkedPage !== '' && isCampaignPageMatch) {
      this.oauthService.redirectUri = globalThis.location.origin + data.campaignLinkedPage;
    }
  }

  private persistCampaignCookie(data: any) {
    const isSecure = globalThis.location.origin.startsWith('https');
    if (isSecure) {
      document.cookie = this.campaignCookieName + "=" + data.id + ";secure;path=/;expires=" + new Date(data.endDate);
    } else {
      document.cookie = this.campaignCookieName + "=" + data.id + ";path=/;expires=" + new Date(data.endDate);
    }
  }

  private bindActiveCampaignFromCookie() {
    const cookie = this.cookieService.get(this.campaignCookieName);
    if (cookie && cookie !== '') {
      this.campaignService.getActiveCampaign("", cookie).subscribe({
        next: (data: any) => this.handleCookieActiveCampaignResponse(data),
        error: () => {}
      });
    }
    else {
      this.showDefaultCampaign = true;
    }
  }

  private handleCookieActiveCampaignResponse(data: any) {
    if (!data) {
      //campaign expired
      this.cookieService.delete(this.campaignCookieName);
      this.showDefaultCampaign = true;
      return;
    }
    this.campaignData = data;
    this.utm_id = data.campaignUtmId || this.utm_id;
    this.showDefaultCampaign = false;
    if (this.campaignData.campaignTypeId !== Enum.CampaignType.LoginPageCampaign) {
      sessionStorage.setItem('isCampaignUserDcQuote', 'true');
    }
    this.bindCampaignText(this.campaignData);

    if (this.campaignData.campaignTypeId !== Enum.CampaignType.LoginPageCampaign) {
      this.router.navigate(['/'], {
        queryParams: this.utm_id ? { utm_id: this.utm_id } : {},
        replaceUrl: true
      });
    }
  }

idNumberCheckForCampaign() {
let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {
      this.campaignService.getActiveCampaign('', campaignCookie).subscribe({
        next: (data: any) => {
          const tileHighlightId = data.tileHighlightId || '';
          const highlightParts: string[] = tileHighlightId ? tileHighlightId.split("#") : ['', ''];
          const highlightParam1 = highlightParts[0] || '';
          const highlightParam2 = highlightParts[1] || '';
          sessionStorage.setItem("productId",highlightParam1)
          sessionStorage.setItem("categoryId",highlightParam2)
        },
        error: () => {}
      });
    }
    localStorage.removeItem('tempToken');
    this.errorMsg = '';

    if (this.idNumberFormCampaign.invalid) {
      this.idNumberFormCampaign.markAllAsTouched();
      return;
    }

    const param = {
      IdNumber: this.idNumberFormCampaign.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      Version: Enum.VersionType.ScsRegistration
    };
    this.idNumber = param.IdNumber;


    this.userService.getUserInfoByIdNumber(param).subscribe({
      next: (data: any) => {
        if (data.isLead) {
          this.isHidden = data.isEmailInRequestParam;
          if (this.isHidden === true) {
            this.registerWithIdnumberForm = this.formBuilder.group({
              IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]],
              Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
              ConfirmPassword: ['', Validators.required],
              Email: ['', [Validators.email, InputValidationService.isValidEmail]],
              FinancialPlannerCode: ['', [Validators.minLength(8)]],
              WebSource: '',
              Params: '',
              RegistrationSource: '',
              AcceptTerms: [false, Validators.pattern('true')]
            }, {
              validator: [
                InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
              ],
            });
          }
          localStorage.setItem('tempToken', data.token);
          $('#id-number-campaign-form').hide();
          $('#auto-register-form').show();
          this.registerWithIdnumberForm.patchValue({ IdNumber: this.idNumber });
          this.idNumberForm.patchValue({ IdNumber: ''});
        }
        else {
          $('#id-number-campaign-form').hide();
          $('#registerForm').show();
          this.registerForm.patchValue({ IdNumber: this.idNumber });
          this.idNumberForm.patchValue({ IdNumber: ''});
        }
      },
      error: (err: HttpErrorResponse) => {
       if (this.isSolUserError(err)) {
         this.solUserModalService.show();
         return;
       }
       if (err.error?.errors) {
          this.errorMsg = Object.values(err.error.errors).flat().join('<br>');
        } else {
          this.errorMsg = err.error;
          this.createMessageLink();
        }
      }
    });
  }


  idNumberCheckForSecondCampaign() {
    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {
      //get utm_id from campaign cookie
      
      this.campaignService.getActiveCampaign('', campaignCookie).subscribe({
        next: (data: any) => {
          const tileHighlightId = data.tileHighlightId || '';
          const highlightParts: string[] = tileHighlightId ? tileHighlightId.split("#") : ['', ''];
          const highlightParam1 = highlightParts[0] || '';
          const highlightParam2 = highlightParts[1] || '';
          sessionStorage.setItem("productId",highlightParam1);
          sessionStorage.setItem("categoryId",highlightParam2);
        },
        error: () => {}
      });

    }
    localStorage.removeItem('tempToken');
    this.errorMsg = '';


    if (this.idNumberFormSecondCampaign.invalid) {
      this.idNumberFormSecondCampaign.markAllAsTouched();
      return;
    }

    const param = {
      IdNumber: this.idNumberFormSecondCampaign.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      Version: Enum.VersionType.ScsRegistration
    };
      this.idNumber = param.IdNumber;
      this.userService.getUserInfoByIdNumber(param).subscribe({
        next: (data: any) =>{
          if (data.isLead) {
            this.isHidden = data.isEmailInRequestParam;
            if (this.isHidden === true) {
              this.registerWithIdnumberForm = this.formBuilder.group({
                IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]],
                Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
                ConfirmPassword: ['', Validators.required],
                Email: ['', [Validators.email, InputValidationService.isValidEmail]],
                FinancialPlannerCode: ['', [Validators.minLength(8)]],
                WebSource: '',
                Params: '',
                RegistrationSource: '',
                AcceptTerms: [false, Validators.pattern('true')]
              }, {
                validator: [
                  InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
                ],
              });
            }
            localStorage.setItem('tempToken', data.token);
            $('#id-number-campaign-form').hide();
            $('#auto-register-form').show();
            this.registerWithIdnumberForm.patchValue({ IdNumber: this.idNumber });
          }
          else {
            $('#id-number-campaign-form').hide();
            $('#registerForm').show();
            this.registerForm.patchValue({ IdNumber: this.idNumber });
          }
        },
        error: (err: HttpErrorResponse) => {  
          if (this.isSolUserError(err)) {
            this.solUserModalService.show();
            return;
          }
          if (err.error?.errors) {
          this.errorMsg = Object.values(err.error.errors).flat().join('<br>');
          } else {
            this.errorMsg = err.error;
            this.createMessageLink();
          }
        }
      });
  }

  functionButton() {
    this.showSecondCampaign = true;
    let cookie = this.cookieService.get(this.campaignCookieName);
    if (cookie && cookie !== '') {
      this.campaignService.getActiveCampaign("", cookie).subscribe({
        next: (data: any) => {
          if (data) {

            this.campaignData = data;
            this.showDefaultCampaign = false;
            this.campaignIdNumberCheck = this.campaignData.campaignIdNumberCheck;
            this.imageUrl= this.campaignData.imageUrl;
            if (this.campaignIdNumberCheck == 'campaignwithoutid') {
              this.campaignSecondCheck = true;
            }
            if (this.campaignSecondCheck == true) {
              this.showCampaignWithOutId = false;
              this.showCampaignWithId = false;
              this.showDefaultCampaign = false;
            }
            let primaryHeadingSecondPage = this.campaignData.primaryHeadingSecondPage.toString();
            let str = primaryHeadingSecondPage;
            let substrings = str.split(' ');
            this.primaryHeadingSecondPage = substrings[0];
            let lengthofString = substrings.length;
            if (substrings.length > 0) {
              for (let i = 1; i <= lengthofString - 1; i++) {
                if (i == 1) {
                  this.primarySeondaryRemaining = substrings[i];
                }
                else {
                  this.primarySeondaryRemaining = this.primarySeondaryRemaining + ' ' + substrings[i];
                }
              }
            };
          }
        },
        error: () => {}
      });
    }

    else {
      this.campaignService.getActiveCampaign(this.utm_id, "").subscribe({
        next: ()=> {
          this.campaignService.getActiveCampaign(this.utm_id, "").subscribe((data: any) => {
            if (data != null) {
              console.log("campaign data", data);
              this.campaignData = data;
              this.campaignIdNumberCheck = this.campaignData.campaignIdNumberCheck;
              if (this.campaignIdNumberCheck == 'campaignwithoutid') {
                this.campaignSecondCheck = true;
              }
              if (this.campaignSecondCheck == true) {
                this.showCampaignWithOutId = false;
                this.showCampaignWithId = false;
                this.showDefaultCampaign = false;
              }
              let imageUrl = this.campaignData.imageUrl;
              let primaryHeadingSecondPage = this.campaignData.primaryHeadingSecondPage.toString();
              let str = primaryHeadingSecondPage;
              let substrings = str.split(' ');
              this.primaryHeadingSecondPage = substrings[0];
              let lengthofString = substrings.length;
              if (substrings.length > 0) {
                for (let i = 1; i <= lengthofString - 1; i++) {
                  if (i == 1) {
                    this.primarySeondaryRemaining = substrings[i];
                  }
                  else {
                    this.primarySeondaryRemaining = this.primarySeondaryRemaining + ' ' + substrings[i];
                  }
    
                  console.log(this.primarySeondaryRemaining);
                }
              }
            }
          });
        }
      });
    }
  }

  bindCampaignText(campaignData) {
let idcheck = campaignData.campaignTypeId;
    this.campaignIdNumberCheck = campaignData.campaignIdNumberCheck;
 if(this.campaignIdNumberCheck!=null){
    if (this.campaignIdNumberCheck.toLowerCase() == 'campaignwithoutid') {
      this.campCheck = true;

    }
    if (this.campaignIdNumberCheck.toLowerCase() == 'campaignwithid') {
      this.showDefaultCampaign = false;
      this.showCampaignWithId = true;

    }
  }
  else{
    this.showDefaultCampaign = true;
    this.showCampaignWithId = false;
  }

  if(idcheck ==1)
  {
  if (this.campaignData.imageUrl) {
    this.imageUrl = this.campaignData.imageUrl;
  }
}
else {
    // Set the URL of the default image
    this.imageUrl = this.defaultImage;
  }

    let primaryHeading = this.campaignData.primaryHeading.toString();
    let substrings = primaryHeading.split(' ');
    this.primaryHeading = substrings[0];
    this.primaryRemaining = this.appendHeadingRemainder(substrings, this.primaryRemaining);

    let secondaryHeading = this.campaignData.secondaryHeading.toString();
    let subSecondstrings = secondaryHeading.split(' ');
    this.secondaryHeading = subSecondstrings[0];
    this.secondaryRemaining = this.appendHeadingRemainder(subSecondstrings, this.secondaryRemaining);

    if (this.campCheck == true) {
      this.showDefaultCampaign = false;
      this.showCampaignWithId = false;
      this.showCampaignWithOutId = true;
    }

  }

  private appendHeadingRemainder(substrings: string[], currentRemaining: string): string {
    let remaining = currentRemaining;
    const lengthofString = substrings.length;
    if (substrings.length > 0) {
      for (let i = 1; i <= lengthofString - 1; i++) {
        if (i == 1) {
          remaining = substrings[i];
        }
        else {
          remaining = remaining + ' ' + substrings[i];
        }

        console.log(remaining);
      }
    }
    return remaining;
  }

  checkIntermediaryLink()
  {
    if (this.utm_id !== undefined && this.code!==undefined) {
     localStorage.setItem('intermediaryDataUtm_id',this.utm_id);
     localStorage.setItem('intermediaryDataCode', this.code.toString());

    }
  }
  trackIntermediaryUserAssociateRegister() {
    const anchor: HTMLAnchorElement = document.querySelector("#documentPdfAssociate");
    anchor.click();
  }
  isTouchDevice(): boolean {
  return globalThis.matchMedia('(hover: none)').matches;
}
  handleClick(event: Event) {   
  if (!this.isTouchDevice()) return;
  event.stopPropagation();
  this.showTooltip = !this.showTooltip;
}

@HostListener('document:click')
onDocumentClick() {
  if (!this.isTouchDevice()) return;
  this.showTooltip = false;
}
}

